import React from 'react'
import { WidgetIcon } from './WidgetIcon'
import { RemoveItemButton } from './RemoveItemButton'
import { useBuilderWidget } from '../TaskCreation/contexts/BuilderWidgetContext'

interface PollHeaderProps {
  onRemove: () => void
  subtaskType: number
  /** Swaps the photo icon for its AI variant — follows the `is_ai_enhanced` switch live. */
  isAiEnhanced?: boolean
}

const WidgetHeader: React.FC<PollHeaderProps> = ({ onRemove, subtaskType, isAiEnhanced }) => {
  const isBuilder = useBuilderWidget()

  if (isBuilder) return null
  return (
    <>
      <RemoveItemButton onRemove={onRemove} />
      <WidgetIcon subtaskType={subtaskType} isAiEnhanced={isAiEnhanced} />
    </>
  )
}
export default WidgetHeader
